import { render, staticRenderFns } from "./MainBase.vue?vue&type=template&id=7a3721bb&scoped=true&"
import script from "./MainBase.vue?vue&type=script&lang=ts&"
export * from "./MainBase.vue?vue&type=script&lang=ts&"
import style0 from "./MainBase.vue?vue&type=style&index=0&id=7a3721bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3721bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
